<template>
  <div class="flex flex-col w-full">
    <label :for="name" class="block text-sm font-medium text-gray-700 h-[24px]">
      <RequiredStar v-if="required" />
      <Translate :value="label" />
    </label>

    <div class="flex flex-row">
      <!-- Dummy hidden input to trick Chrome -->
      <input
        type="text"
        style="display: none;"
        :name="`fake-${name}`"
        autocomplete="off"
      />

      <input
        :id="name"
        :name="name"
        :type="type"
        :value="modelValue"
        :max="max"
        :min="min"
        @input="$emit('update:modelValue', $event.target.value)"
        :autocomplete="`new-${name}`"
        class="mt-1 sm:mt-2 block w-full border border-gray-400 shadow-sm focus:ring-main focus:border-main p-2 sm:p-3 text-xs md:text-base"
        :class="inputClassF()"
        :placeholder="Translate(placeholder)"
        :required="required"
        :disabled="disabled"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import RequiredStar from '@/components/Form/RequiredStar.vue';

export default {
  name: "InputComponent",
  components: {
    RequiredStar
  },
  props: {
    label: { type: String, required: true },
    name: { type: String, required: true },
    type: { type: String, default: "text" },
    modelValue: { type: [String, Number], default: "" },
    max: { type: String, default: undefined },
    min: { type: String, default: undefined },
    placeholder: { type: String, default: '' },
    disablePlaceholderTranslation: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inputClass: { type: String, default: '' },
    valid: { type: Boolean, default: undefined }
  },
  methods: {
    Translate(key) {
      if (!key || key === '' || this.disablePlaceholderTranslation) return key;
      return this.$languageStore.getTranslation(key);
    },
    inputClassF() {
      if (this.valid === undefined || this.disabled) {
        return this.inputClass;
      }
      return this.valid
        ? 'valid-input'
        : 'invalid-input';
    }
  },
  emits: ['update:modelValue']
};
</script>
